import { FormEvent, useEffect, useState } from "react";
import { FCWithChildren } from "../../../interfaces/FCWithChildren";
import { SLogin } from "../login-and-reset-request/login/Styles/SLogin";
import { SLoginImage } from "../login-and-reset-request/login/Styles/SLoginImage";
import { SLoginWrapper } from "../login-and-reset-request/login/Styles/SLoginWrapper";
import { RegisterContactInfoHeader } from "./contact-info/RegisterContactInfoHeader";
import { SRegisterForm } from "./styles/SRegisterForm";

interface IRegisterForm {
  images: React.ReactNode;
  color: string;
  onSubmit: (e: FormEvent<Element>) => void;
}

export const RegisterForm: FCWithChildren<IRegisterForm> = ({ children, images, color, onSubmit }) => {
  const [isFirstRendered, setIsFirstRendered] = useState(false);

  useEffect(() => {
    setIsFirstRendered(true);
  }, []);

  return (
    <SLogin style={{ display: isFirstRendered ? "flex" : "none" }}>
      <SLoginWrapper>
        <RegisterContactInfoHeader />
        <SRegisterForm autoComplete="off" onSubmit={onSubmit}>
          {children}
        </SRegisterForm>
      </SLoginWrapper>
      <SLoginImage color={color}>{images}</SLoginImage>
    </SLogin>
  );
};
